export const analyticsId = {
    PRE_GRANTED_CREDIT_STEP_1_VIEW: "PRE_GRANTED_CREDIT_STEP_1_VIEW",
    PRE_GRANTED_CREDIT_STEP_2_VIEW: "PRE_GRANTED_CREDIT_STEP_2_VIEW",
    PRE_GRANTED_CREDIT_STEP_3_VIEW: "PRE_GRANTED_CREDIT_STEP_3_VIEW",
    PRE_GRANTED_CREDIT_STEP_1_SUCCESS: "PRE_GRANTED_CREDIT_STEP_1_SUCCESS",
    PRE_GRANTED_CREDIT_STEP_2_SUCCESS: "PRE_GRANTED_CREDIT_STEP_2_SUCCESS",
    PRE_GRANTED_CREDIT_STEP_3_SUCCESS: "PRE_GRANTED_CREDIT_STEP_3_SUCCESS",
    PRE_GRANTED_CREDIT_WIZARD_ERROR: "PRE_GRANTED_CREDIT_WIZARD_ERROR",
    PRE_GRANTED_CREDIT_WIZARD_SUCCESS: "PRE_GRANTED_CREDIT_WIZARD_SUCCESS",
};

const commonFields = () => ({
    sectionFamily: "banking",
    sectionCategory: "products",
    sectionName: "loans",
    serviceType: "productContracting",
    interactionType: "funnel",
    processType: "loanContracting",
});

export const catalogue = {
    [analyticsId.PRE_GRANTED_CREDIT_STEP_1_VIEW]: () => ({
        ...commonFields(),
        event_name: "step_uvp",
        pageName: "/loanContracting/step1/uvp",
        processStep: "step1",
        processDetail: "uvp",
        productName: "pregrantedCredit",
    }),
    [analyticsId.PRE_GRANTED_CREDIT_STEP_2_VIEW]: () => ({
        ...commonFields(),
        event_name: "step_account_selection",
        pageName: "/loanContracting/step2/accountSelection",
        processStep: "step2",
        processDetail: "accountSelection",
        productName: "pregrantedCredit",
    }),
    [analyticsId.PRE_GRANTED_CREDIT_STEP_3_VIEW]: () => ({
        ...commonFields(),
        event_name: "step_confirmation",
        pageName: "/loanContracting/step3/confirmation",
        processStep: "step3",
        processDetail: "confirmation",
        productName: "pregrantedCredit",
    }),
    [analyticsId.PRE_GRANTED_CREDIT_STEP_1_SUCCESS]: () => ({
        event_name: "event_success",
        action: "success",
        format: "steps",
        component: "funnel",
        element: "uvp",
    }),
    [analyticsId.PRE_GRANTED_CREDIT_STEP_2_SUCCESS]: () => ({
        event_name: "event_success",
        action: "success",
        format: "steps",
        component: "funnel",
        element: "accountSelection",
    }),
    [analyticsId.PRE_GRANTED_CREDIT_STEP_3_SUCCESS]: () => ({
        event_name: "event_success",
        action: "success",
        format: "steps",
        component: "funnel",
        element: "confirmation",
    }),
    [analyticsId.PRE_GRANTED_CREDIT_WIZARD_ERROR]: ({ errorMessage }) => ({
        ...commonFields(),
        event_name: "step_error",
        pageName: "/loanContracting/error",
        processStep: "error",
        errorCategory: "requestNotApproved",
        productName: "pregrantedCredit",
        errorDescription: errorMessage,
    }),
    [analyticsId.PRE_GRANTED_CREDIT_WIZARD_SUCCESS]: () => ({
        ...commonFields(),
        event_name: "step_success",
        pageName: "/loanContracting/success",
        processStep: "success",
        productName: "pregrantedCredit",
    }),
};
